import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { ReactiveFormsModule } from '@angular/forms';
import { EffectsModule } from '@ngrx/effects';
import { StoreModule } from '@ngrx/store';

import { MaterialModule } from '@material/material.module';
import { InviteToApplyComponent } from '@shared/invite-to-apply/invite-to-apply.component';
import { InviteToApplyModalComponent } from '@shared/invite-to-apply/modal/invite-to-apply-modal.component';
import { HcmJobPostService } from '@shared/invite-to-apply/services/hcm-job-post.service';
import { InviteToApplyService } from '@shared/invite-to-apply/services/invite-to-apply.service';
import { InviteToApplyEffects } from '@shared/invite-to-apply/store/invite-to-apply.effects';
import { jobPostUrlReducer } from '@shared/invite-to-apply/store/invite-to-apply.reducer';
import { LoaderModule } from '@shared/loader/loader.module';
import { ThumbModule } from '@shared/thumb/thumb.module';
import { MojoAutocompleteModule } from 'mojo-autocomplete';
import { InviteToApplyAutocompleteModalComponent } from './invite-to-apply-autocomplete-modal/invite-to-apply-autocomplete-modal.component';

@NgModule({
  declarations: [
    InviteToApplyComponent,
    InviteToApplyModalComponent,
    InviteToApplyAutocompleteModalComponent,
  ],
  imports: [
    CommonModule,
    MaterialModule,
    ThumbModule,
    ReactiveFormsModule,
    StoreModule.forFeature('jobPostUrlFeatureSelector', jobPostUrlReducer),
    EffectsModule.forFeature([InviteToApplyEffects]),
    MojoAutocompleteModule,
    LoaderModule,
  ],
  exports: [InviteToApplyComponent],
  providers: [InviteToApplyService, HcmJobPostService],
})
export class InviteToApplyModule {}
